export default "__VITE_ASSET__77cfe17f__"